"use client";

import { Select, SelectProps, Tag } from "antd";
import styles from "./index.module.css";
import { useRef, useState } from "react";
import CaretDown from "assets/svg/CaretDown.svg";

type TagRender = SelectProps["tagRender"];

export const CustomSelect = (props: SelectProps & { isHiddenArrow?: boolean }) => {
  const [isShowSuffixIcon, setIsShowSuffixIcon] = useState(true);
  const selected = useRef("");

  const tagRender: TagRender = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} className={styles.customTag}>
        {label}
      </Tag>
    );
  };

  return (
    <Select
      {...props}
      tagRender={props.mode === "multiple" ? tagRender : undefined}
      maxTagCount={2}
      maxTagPlaceholder={(omittedValues) => <span>+{omittedValues.length}</span>}
      classNames={{
        root: `${props.className ?? ""} ${styles.select} ${props.mode === "multiple" ? styles.multiple : ""} ${
          props.disabled ? `${styles.disabled}` : ""
        }`,
        popup: { root: styles.popup },
      }}
      suffixIcon={
        <img
          src={CaretDown}
          alt="dropdown"
          className={styles.suffixIcon}
          style={{ visibility: isShowSuffixIcon ? "visible" : "hidden" }}
        />
      }
      onChange={(value, options) => {
        selected.current = value;
        if (props?.onChange) {
          props.onChange(value, options);
        }
      }}
      onMouseEnter={
        props.isHiddenArrow
          ? () => {
              if (selected.current) setIsShowSuffixIcon(false);
            }
          : null
      }
      onMouseLeave={
        props.isHiddenArrow
          ? () => {
              setIsShowSuffixIcon(true);
            }
          : null
      }
      onClear={
        props.isHiddenArrow
          ? () => {
              setIsShowSuffixIcon(true);
            }
          : null
      }
    />
  );
};
